/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2023, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */
;
"use strict";

window.yii.getIsGuest = function() {
	return $('meta[name="auth"]').attr('content') !== '1';
};
window.yii.getIsAuth = function() {
	return $('meta[name="auth"]').attr('content') === '1';
};
window.yii.getThemeUrl = function() {
	return $('meta[name="theme-url"]').attr('content');
};
window.yii.getAssetUrl = function(asset) {
	return yii.getThemeUrl() + '/' + asset.replace(/^\//, '');
};

function formatBytes(bytes, decimals) {
	if(bytes === 0) {
		return '0 bytes';
	}
	var k = 1024,
		dm = decimals || 2,
		sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
		i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
